<template>
  <div id="wrapper">
    <navigation></navigation>

    <div id="page-wrapper" class="gray-bg">
      <top-bar></top-bar>

      <component v-if="havePageHeading" :is="headingComponent"></component>

      <div class="wrapper wrapper-content" v-show="notLoading">
        <router-view></router-view>
      </div>
      <div class="wrapper wrapper-content" v-show="loading">&nbsp;</div>

      <div class="footer">
        <div class="pull-right">
          <strong>Copyright</strong> Arrow Logistics {{ currentYear }}
        </div>
      </div>

      <terms-and-conditions></terms-and-conditions>

      <div class="modal fade modal-disabled-help" tabindex="-1" role="dialog" v-if="$user.isDisabled">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <h4 class="modal-title"><i class="fa fa-question-circle"></i> Account Help</h4>
            </div>
            <div class="modal-body">
              <p><strong>Account Disabled</strong></p>
              <p>
                A disabled account has limited access to features and functionality of the Arrow Logistics application. Accounts may be automatically disabled if you have overdue invoices. Please contact Arrow Logistics administration for more information.
              </p>
            </div>
            <div class="modal-footer">
              <a href="#" class="btn btn-sm btn-default text-uppercase" data-dismiss="modal" aria-label="Close">Close</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { has } from 'lodash'
  import Navigation from './Navigation'
  import TopBar from './TopBar'
  import pusher from 'utils/pusher'
  import moment from 'moment'
  import $ from 'jquery'
  import TermsAndConditions from 'components/TermsAndConditions'

  export default {
    name: 'app',

    components: {
      Navigation,
      TopBar,
      TermsAndConditions
    },

    watch: {
      '$route' () {
        this.fixPageWrapperHeight()
      }
    },

    created () {
      pusher.connect()

      if (this.$route.query && this.$route.query.pusher === 'test') {
        this.$echo.private('test').listen('TestPrivateBroadcast', e => console.log(`Test private broadcast message: ${e.message}`))
        this.$echo.channel('test').listen('TestPublicBroadcast', e => console.log(`Test public broadcast message: ${e.message}`))
      }
    },

    mounted () {
      $('body').addClass('fixed-sidebar fixed-nav').removeClass('pace-top')

      this.fixPageWrapperHeight()
      this.addOrRemoveBodySmall()

      $(window).bind('resize', () => {
        this.addOrRemoveBodySmall()

        if (!$('body').hasClass('body-small')) {
          this.fixPageWrapperHeight()
        }
      })

      $('body').tooltip({
        selector: '[data-toggle=tooltip]'
      })
    },

    computed: {
      /**
       * Map the loading state for the application.
       */
      ...mapState('app', ['loading']),

      /**
       * The current year.
       *
       * @return string
       */
      currentYear () {
        return moment().format('YYYY')
      },

      /**
       * Determine if not loading.
       *
       * @return {[type]}
       */
      notLoading () {
        return !this.loading
      },

      /**
       * Return the page heading component.
       *
       * @return object
       */
      headingComponent () {
        return this.$route.meta.heading
      },

      /**
       * Determine if page has a heading.
       *
       * @return boolean
       */
      havePageHeading () {
        return has(this.$route.meta, 'heading')
      }
    },

    methods: {
      /**
       * Add or remove the "body-small" class on the body tag.
       */
      addOrRemoveBodySmall () {
        if ($(window).width() < 769) {
          $('body').addClass('body-small')
        } else {
          $('body').removeClass('body-small')
        }
      },

      /**
       * Fix page wrapper heigh on page resize.
       */
      fixPageWrapperHeight () {
        let navHeight = $('nav.navbar-default').height() - 60
        let wrapperHeight = $('#page-wrapper').height() - 60

        if (navHeight > wrapperHeight) {
          $('#page-wrapper').css('min-height', `${navHeight}px`)
        }

        if (navHeight < wrapperHeight) {
          $('#page-wrapper').css('min-height', `${$(window).height()}px`)
        }

        if ($('body').hasClass('fixed-nav')) {
          if (navHeight > wrapperHeight) {
            $('#page-wrapper').css('min-height', `${navHeight}px`)
          } else {
            $('#page-wrapper').css('min-height', `${$(window).height() - 60}px`)
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?fd1995b2